module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/404-33a38503f158f91949af6f75629e7348.svg";